import {
    POST_UPDATE_CUSTOMER_APPROVAL_REQUEST_LOADING,
    POST_UPDATE_CUSTOMER_APPROVAL_REQUEST_SUCCESS,
    POST_UPDATE_CUSTOMER_APPROVAL_REQUEST_FAILURE
    
} from '../../actions/types';

const INITIAL_STATE = {
    event: {
        post: {
            loading: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        },
    },
};

const updateCustomerApprovalRequestReducers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case  POST_UPDATE_CUSTOMER_APPROVAL_REQUEST_LOADING:
            return {
                ...state,
                event: {
                    ...state.event,
                    post: {
                        ...state.event.post,
                        loading: true,
                        success: {
                            ...state.event.post.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case POST_UPDATE_CUSTOMER_APPROVAL_REQUEST_SUCCESS:
            return {
                ...state,
                event: {
                    ...state.event,
                    post: {
                        ...state.event.post,
                        loading: false,
                        success: {
                            ...state.event.post.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case POST_UPDATE_CUSTOMER_APPROVAL_REQUEST_FAILURE:
            return {
                ...state,
                event: {
                    ...state.event,
                    post: {
                        ...state.event.post,
                        loading: false,
                        success: {
                            ...state.event.post.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
    }
    return state;
}

export default updateCustomerApprovalRequestReducers;
